import { render, staticRenderFns } from "./AreaEmbargadaRoPonto.vue?vue&type=template&id=5477a248&lang=pug"
import script from "./AreaEmbargadaRoPonto.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaRoPonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports